import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qr-component-viewer" }
const _hoisted_2 = { class: "tiny text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_qr = _resolveComponent("icon-qr")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "qr-placeholder",
      style: _normalizeStyle({
                 width: _ctx.item.size + 'px',
                 height: _ctx.item.size + 'px'
             })
    }, [
      _createVNode(_component_icon_qr, { style: {"font-size":"3rem"} }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "small mt-2" }, "QR Code", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pxToCm(_ctx.item.size)) + "cm", 1)
    ], 4)
  ]))
}